import { BufferInfo } from './../model/api-services/layer-api.service';
import { LngLatBoundsLike } from 'mapbox-gl';
import { PrecisionType } from '../components/dialogs/scale-and-location-dialog/scale-and-location-dialog';
import { PixoSpatial, SpatialUnits } from './../model/Pixospatial';
import { Injectable } from '@angular/core';


export type ScaleInfo = {
  length: number,
  units: SpatialUnits,
  precisionType: PrecisionType,
  precision?: number,
  pxDistance?: number
}

@Injectable({
  providedIn: 'root'
})
export class ScaleService {
  static mapScale: ScaleInfo;
  static SetScale(info: ScaleInfo) {
    this.mapScale = info;
  }
  static GetScale(): ScaleInfo | undefined {
    return this.mapScale;
  }
  static GetBufferFromPxDistance(pxBufferDistance: number): number | undefined {
    if(ScaleService.mapScale?.pxDistance === undefined) return undefined;
    const meterDistance = PixoSpatial.SpatialDistanceChange(ScaleService.mapScale.length, ScaleService.mapScale.units, 'meters-m')?.distance;
    if(!meterDistance) return undefined;
    const meterPerPx = meterDistance / ScaleService.mapScale.pxDistance;
    const meterBuffer = pxBufferDistance * meterPerPx;
    return meterBuffer;
  }
}
